import { CSSProperties, FC, memo } from 'react';
import { LazyLoadImage as LazyImageLoad } from 'react-lazy-load-image-component';

import 'react-lazy-load-image-component/src/effects/blur.css';

const visibleByDefault =
  typeof window !== 'undefined' && window.IS_SSR
    ? true
    : typeof window !== 'undefined' &&
      window.navigator.userAgent.includes('Version/15.1 Safari');

type Effect = 'blur' | 'opacity';

interface LazyLoadImageProps {
  className?: string;
  src: string;
  alt: string;
  width?: string;
  height?: string;
  effect?: Effect | null;
  onLoad?: React.ReactEventHandler<HTMLImageElement>;
  onError?: React.ReactEventHandler<HTMLImageElement>;
  placeholderSrc?: string;
  visibleByDefault?: boolean;
  style?: CSSProperties;
  draggable?: boolean;
}

export const LazyLoadImage: FC<LazyLoadImageProps> = memo(
  ({
    className,
    src,
    alt,
    width = '100%',
    height = '100%',
    effect = null,
    onLoad,
    onError,
    placeholderSrc,
    style,
    visibleByDefault: visibleByDefaultProp = visibleByDefault,
    draggable
  }) => {
    return (
      <LazyImageLoad
        className={className}
        src={src}
        alt={alt}
        width={width}
        height={height}
        effect={effect || undefined}
        onLoad={onLoad}
        onError={onError}
        threshold={600}
        placeholderSrc={placeholderSrc}
        style={style}
        visibleByDefault={visibleByDefaultProp}
        draggable={draggable}
      />
    );
  }
);
